import * as React from "react"
import { CommandInput } from "@ui/shad"
import { Loader2 } from "lucide-react"

interface SearchBarProps {
  searchQuery: string
  isSearching: boolean
  onSearchChange: (value: string) => void
  placeholder?: string
  autoFocus?: boolean
}

export function SearchBar({
  searchQuery,
  isSearching,
  onSearchChange,
  placeholder = "Search clients, prospects, contacts, or opportunities...",
  autoFocus = false,
}: SearchBarProps) {
  const inputRef = React.useRef<HTMLInputElement>(null)

  React.useEffect(() => {
    if (autoFocus) {
      inputRef.current?.focus()
      inputRef.current?.select()
    }
  }, [autoFocus])

  return (
    <div className="relative">
      <CommandInput ref={inputRef} placeholder={placeholder} value={searchQuery} onValueChange={onSearchChange} />
      {isSearching && (
        <div className="absolute top-1/2 right-3 -translate-y-1/2">
          <Loader2 className="text-icon-muted h-4 w-4 animate-spin" />
        </div>
      )}
    </div>
  )
}
